import React, { createContext, useContext, useState, ReactNode } from 'react';

interface VideoPlayerContextType {
    activePlayerId: string | null;
    setActivePlayer: (_id: string | null) => void;
}

const VideoPlayerContext = createContext<VideoPlayerContextType | undefined>(
    undefined
);

export const VideoPlayerProvider = ({ children }: { children: ReactNode }) => {
    const [activePlayerId, setActivePlayerId] = useState<string | null>(null);

    return (
        <VideoPlayerContext.Provider
            value={{ activePlayerId, setActivePlayer: setActivePlayerId }}
        >
            {children}
        </VideoPlayerContext.Provider>
    );
};

export const useVideoPlayer = () => {
    const context = useContext(VideoPlayerContext);
    if (!context) {
        throw new Error(
            'useVideoPlayer must be used within a VideoPlayerProvider'
        );
    }
    return context;
};
